export default "__VITE_ASSET__BjFwi8Fr__"